(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mig-discount-popup"] && !Shopify.designMode) return;
  try {
    function initMigDiscountPopup() {
    var modal = document.querySelector('[data-mig-discount-modal]');
    if (!modal || modal.dataset.initialized === 'true') return;

    modal.dataset.initialized = 'true';
    var lastTrigger = null;
    var form = modal.querySelector('#MigDiscountForm');
    var signupView = modal.querySelector('[data-mig-discount-signup-view]');
    var successView = modal.querySelector('[data-mig-discount-success-view]');
    var status = modal.querySelector('[data-mig-discount-status]');
    var submitButton = modal.querySelector('.mig-discount-submit');

    function openModal(trigger) {
      lastTrigger = trigger || null;
      modal.hidden = false;
      document.body.classList.add('mig-discount-modal-open');
      var focusTarget = null;
      if (successView && !successView.hidden) {
        focusTarget = modal.querySelector('[data-mig-discount-copy]');
      } else {
        focusTarget = modal.querySelector('.mig-discount-input');
      }
      if (!focusTarget) focusTarget = modal.querySelector('[data-mig-discount-close]');
      if (focusTarget) focusTarget.focus();
    }

    function showDiscountCode() {
      if (signupView) signupView.hidden = true;
      if (successView) successView.hidden = false;
      var copyButton = modal.querySelector('[data-mig-discount-copy]');
      if (copyButton) copyButton.focus();
      try {
        window.sessionStorage.setItem('migDiscountUnlocked', 'true');
      } catch (error) {
        // Storage can be unavailable in private browsing.
      }
    }

    function closeModal() {
      modal.hidden = true;
      document.body.classList.remove('mig-discount-modal-open');
      if (lastTrigger) lastTrigger.focus();
    }

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-mig-discount-trigger]');
      if (trigger) {
        event.preventDefault();
        openModal(trigger);
        return;
      }

      if (event.target.closest('[data-mig-discount-close]')) {
        event.preventDefault();
        closeModal();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !modal.hidden) closeModal();
    });

    var copyButton = modal.querySelector('[data-mig-discount-copy]');
    if (copyButton) {
      copyButton.addEventListener('click', function () {
        var code = copyButton.dataset.code;
        var label = copyButton.querySelector('small');
        function markCopied() {
          copyButton.classList.add('is-copied');
          if (label) label.textContent = 'Copied';
        }
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(markCopied).catch(markCopied);
        } else {
          markCopied();
        }
      });
    }

    if (form && signupView && successView) {
      form.addEventListener('submit', function (event) {
        if (!form.checkValidity()) return;
        if (!window.fetch || !window.FormData) return;

        event.preventDefault();
        if (submitButton) {
          submitButton.disabled = true;
          submitButton.textContent = 'Sending...';
        }
        if (status) {
          status.hidden = false;
          status.textContent = 'Saving your email...';
        }

        fetch(form.action, {
          method: 'POST',
          body: new FormData(form),
          credentials: 'same-origin',
          headers: {
            Accept: 'text/html',
          },
        })
          .then(function () {
            if (status) status.textContent = 'Saved. Your code is ready.';
            showDiscountCode();
          })
          .catch(function () {
            form.submit();
          })
          .finally(function () {
            if (submitButton) {
              submitButton.disabled = false;
              submitButton.textContent = 'Get discount code';
            }
          });
      });
    }

    try {
      if (window.sessionStorage.getItem('migDiscountUnlocked') === 'true') showDiscountCode();
    } catch (error) {
      // Storage can be unavailable in private browsing.
    }

    if (window.location.hash === '#discount-code' || (successView && !successView.hidden)) openModal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMigDiscountPopup);
  } else {
    initMigDiscountPopup();
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["purchase-policy-notice"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('policy-consent')) {
    customElements.define('policy-consent', class extends HTMLElement {
      connectedCallback() {
        this.checkbox = this.querySelector('input[type="checkbox"]');
        this.timestamp = this.querySelector('[data-policy-consent-time]');
        this.error = this.querySelector('[role="alert"]');
        this.form = document.getElementById(this.checkbox?.getAttribute('form'));
        this.checkoutButtons = this.form
          ? Array.from(document.querySelectorAll(`[name="checkout"][form="${this.form.id}"], #${this.form.id} [name="checkout"]`))
          : [];

        if (!this.checkbox || !this.form) return;

        this.updateState();
        this.checkbox.addEventListener('change', () => this.updateState());
        this.form.addEventListener('submit', (event) => {
          if (!this.checkbox.checked) {
            event.preventDefault();
            this.error.hidden = false;
            this.checkbox.focus();
          }
        });
      }

      updateState() {
        const accepted = this.checkbox.checked;
        this.checkoutButtons.forEach((button) => {
          button.disabled = !accepted;
          button.setAttribute('aria-disabled', String(!accepted));
        });
        this.error.hidden = true;
        this.timestamp.value = accepted ? new Date().toISOString() : '';
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
